import { hasKeys } from './util';
export const hasApiError = (error) => hasKeys(error);
export const isLoginFailed = (payload) => payload.request === 'POST /api/v1/auth/login' && payload.status === 401;
export const authenticationErrorFromApiResponse = (payload) => {
    if (isLoginFailed(payload) && payload.additionalErrors) {
        const { loginAttempts, unlockTimestamp, lockTimestamp, userStatus } = payload.additionalErrors;
        return {
            loginAttempts,
            unlockTimestamp: unlockTimestamp ? new Date(unlockTimestamp) : undefined,
            lockTimestamp: lockTimestamp ? new Date(lockTimestamp) : undefined,
            userStatus,
        };
    }
    return undefined;
};
